import React from "react";
import { IconProps } from "./IconProps";

const Calculator: React.FC<IconProps> = ({
    size = 22,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 25"
            fill="none"
            {...props}
        >
            <path
                d="M17.5 6.8302L6.5 17.8302M8.5 10.8302V6.8302M6.5 8.8302H10.5M13.5 15.8302H17.5M7.8 21.3302H16.2C17.8802 21.3302 18.7202 21.3302 19.362 21.0032C19.9265 20.7156 20.3854 20.2567 20.673 19.6922C21 19.0504 21 18.2104 21 16.5302V8.1302C21 6.45004 21 5.60996 20.673 4.96823C20.3854 4.40374 19.9265 3.9448 19.362 3.65718C18.7202 3.3302 17.8802 3.3302 16.2 3.3302H7.8C6.11984 3.3302 5.27976 3.3302 4.63803 3.65718C4.07354 3.9448 3.6146 4.40374 3.32698 4.96823C3 5.60996 3 6.45004 3 8.1302V16.5302C3 18.2104 3 19.0504 3.32698 19.6922C3.6146 20.2567 4.07354 20.7156 4.63803 21.0032C5.27976 21.3302 6.11984 21.3302 7.8 21.3302Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Calculator;
